import axios, { AxiosHeaders } from "axios";

type FetchTokenCallback = () => Promise<string>;

const baseURL = import.meta.env.VITE_API_BASE_URL;

if (!baseURL) {
  throw new Error(
    "VITE_API_BASE_URL is not defined. Please configure it in your environment.",
  );
}

export const httpClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

let isAuthInterceptorAttached = false;

export const attachAuthTokenInterceptor = (
  fetchToken: FetchTokenCallback,
): void => {
  // 予防策として、同じリクエストフックが複数回登録されることを防ぐ。
  // 実際のトークン取得は各リクエスト直前に fetchToken が都度実行される。
  if (isAuthInterceptorAttached) {
    return;
  }

  httpClient.interceptors.request.use(
    async (config) => {
      const token = await fetchToken();

      if (token) {
        const headers = AxiosHeaders.from(config.headers);
        headers.set("Authorization", `Bearer ${token}`);
        config.headers = headers;
      }

      return config;
    },
    (error) => Promise.reject(error),
  );

  isAuthInterceptorAttached = true;
};

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // 必要に応じて共通エラーハンドリングを追加
    return Promise.reject(error);
  },
);
